module.exports = __webpack_public_path__ + "static/media/share.f568605f.png";